export default __webpack_public_path__ + "static/media/play_button_red.7df91928.png";